import React from 'react';

export default function Footer() {
  return (
    <footer className="app-footer" style={{ padding: '2rem 1rem' }}>
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        gap: '2rem',
        maxWidth: '1200px',
        margin: '0 auto',
      }}>
        {/* 1. Brand & Socials */}
        <div style={{ flex: '1 1 200px', minWidth: 180 }}>
          <div style={{ fontFamily: 'Playfair Display, serif', fontSize: '2rem', marginBottom: '1rem' }}>
            Szakacs Visuals
          </div>
          <div className="social-icons" style={{ marginBottom: '1rem' }}>
            <a href="https://www.instagram.com/szakacs.visuals/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" 
               style={{ margin: '0 0.8rem', color: '#fff', fontSize: '1.5rem', transition: 'transform 0.3s ease' }}
               onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.2)'}
               onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}>
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://youtube.com/" target="_blank" rel="noopener noreferrer" aria-label="YouTube"
               style={{ margin: '0 0.8rem', color: '#fff', fontSize: '1.5rem', transition: 'transform 0.3s ease' }}
               onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.2)'}
               onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}>
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://tiktok.com/" target="_blank" rel="noopener noreferrer" aria-label="TikTok"
               style={{ margin: '0 0.8rem', color: '#fff', fontSize: '1.5rem', transition: 'transform 0.3s ease' }}
               onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.2)'}
               onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}>
              <i className="fab fa-tiktok"></i>
            </a>
          </div>
          <p>© 2025 Szakacs Visuals. All rights reserved.</p>
        </div>
        {/* 2. About Text */}
        <div style={{ flex: '2 1 300px', minWidth: 220, fontSize: '1rem', fontFamily: 'Montserrat, Open Sans, Arial, sans-serif', lineHeight: 1.6 }}>
          I'm Tamas, a photographer and videographer based in Bristol, with a passion for storytelling through a cinematic lens. I capture life's special moments—weddings, christenings, and celebrations—and help businesses stand out with real estate walkthroughs, car photography, and product shoots. While I'm rooted in the South West and Wales, I'm happy to travel across the UK to bring your vision to life.
        </div>
        {/* 3. Contact Details */}
        <div style={{ flex: '1 1 200px', minWidth: 180, fontSize: '1rem', fontFamily: 'Montserrat, Open Sans, Arial, sans-serif' }}>
          <div style={{ marginBottom: '0.5rem', fontWeight: 500 }}>Contact</div>
          <div>+44 7547 546 171</div>
          <div>szakacs.visuals@gmail.com</div>
          <div>Bristol, UK</div>
        </div>
        {/* 4. Pages/Links */}
        <div style={{ flex: '1 1 180px', minWidth: 150, fontSize: '1rem', fontFamily: 'Montserrat, Open Sans, Arial, sans-serif' }}>
          <div><a href="/terms" style={{ color: '#fff', textDecoration: 'none', display: 'block', marginBottom: 4 }}>Terms & Conditions</a></div>
          <div><a href="/privacy" style={{ color: '#fff', textDecoration: 'none', display: 'block', marginBottom: 4 }}>Privacy Policy</a></div>
          <div><a href="/returns" style={{ color: '#fff', textDecoration: 'none', display: 'block', marginBottom: 4 }}>Return Policy</a></div>
          <div><a href="/digital-policy" style={{ color: '#fff', textDecoration: 'none', display: 'block', marginBottom: 4 }}>Digital Product Policy</a></div>
        </div>
      </div>
    </footer>
  );
}
